<template>
  <svg
    viewBox="0 0 24 24"
    width="24"
    height="24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.9"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true">
    <path d="M12 3l2.2 5.6L20 10l-5.1 2-1.9 6-2-6L6 10l5.7-1.4L12 3z" />
  </svg>
</template>
